import { customHeaders, requestApi } from 'api/api'
import { v4 as uuidv4 } from 'uuid'
import {
  PayoutRequest,
  PayoutResponse,
  TransferRequest,
  TransferResponse,
  TransferWalletsReponse,
  TransferWalletsRequest,
} from 'types/unifiedPayouts/unifiedPayouts'

export const postPayoutsTransfer = (data: TransferRequest): Promise<TransferResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/payment/v1/transfers',
    method: 'POST',
    data,
    headers: {
      'x-idempotency-key': uuidv4(),
    },
  })
}

export const getPayoutsTransferWallets = ({
  walletId,
  currencyCode,
  walletType,
  customerReference,
}: TransferWalletsRequest): Promise<TransferWalletsReponse[]> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: `/payment/v1/transfers/${walletId}/beneficiaries`,
    method: 'GET',
    params: {
      ...(currencyCode && { currencyCode }),
      ...(customerReference && { customerReference }),
      ...(walletType && { walletType }),
    },
  })
}

export const postPayout = (data: PayoutRequest): Promise<PayoutResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/payment/v1/payouts',
    method: 'POST',
    data,
    headers: {
      ...customHeaders,
      'x-idempotency-key': uuidv4(),
    },
  })
}
